import { useContext } from 'react';
import { FeatureFlagsContext } from './FeatureFlagsContextStore';

export function useFeatureFlags() {
	const { featureFlags, isLoading } = useContext(FeatureFlagsContext);

	return { ...featureFlags, isLoading };
}
